import React from 'react';

import Typography from '../../library/typography/typography';

interface GroupAffiliationPromotionTitleProps {
  className?: string;
  showTitle?: boolean;
  title: string;
}
function GroupAffiliationPromotionTitle(
  props: GroupAffiliationPromotionTitleProps
) {
  const { className, showTitle, title } = props;

  return (
    <>
      {showTitle && title && (
        <Typography className={className} tag="div" variant="H6" weight="black">
          {title}
        </Typography>
      )}
    </>
  );
}

export default GroupAffiliationPromotionTitle;
